import { REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN } from '../config/env';

export const multimediaEpaycoOrigin = REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN;

export const multimediaEpaycoUrl = (path) =>
  path ? `${multimediaEpaycoOrigin}${path}` : multimediaEpaycoOrigin;
